module.exports = __webpack_public_path__ + "static/media/daily_bonus_icon.8ab063cb.svg";